import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

export type DraftLot = {
  acquisitionDate: string;
  quantity: string;
  costBasisUsd: string;
};

export interface TaxCenterDraftsState {
  lotsByTransactionId: Record<string, DraftLot[]>;
}

const initialState: TaxCenterDraftsState = {
  lotsByTransactionId: {},
};

const taxCenterDraftsSlice = createSlice({
  name: "taxCenterDrafts",
  initialState,
  reducers: {
    setDraftLots: (
      state: TaxCenterDraftsState,
      action: PayloadAction<{ transactionId: string; lots: DraftLot[] }>,
    ): void => {
      state.lotsByTransactionId[action.payload.transactionId] = action.payload.lots;
    },
    clearDraftLots: (state: TaxCenterDraftsState, action: PayloadAction<string>): void => {
      delete state.lotsByTransactionId[action.payload];
    },
  },
});

export const { setDraftLots, clearDraftLots } = taxCenterDraftsSlice.actions;

export const useDraftLotsForTransaction = (transactionId: string): DraftLot[] | undefined =>
  useAppSelector((state) => state.taxCenterDrafts.lotsByTransactionId[transactionId]);

export default taxCenterDraftsSlice;
